import { useEnvConfigStore } from "@/store/env.store";
import axios from "axios";

export default class FlowiseAIApiServices {
  envConfigStore= useEnvConfigStore()
  async postMethod(url: string, data: any={}) {
    const baseUrl = process.env.NODE_ENV == 'production' ?  this.envConfigStore.aiChatBotKeys?.SpanBotUrl  :'/flowiseapi/'
    url = baseUrl + 'api/v1/' + url;
    try {
      const response = await axios({
        method: "post",
        // headers:
        // {
        //       Username: this.envConfigStore.aiChatBotKeys?.SpanBotUserName,
        //       Password: this.envConfigStore.aiChatBotKeys?.SpanBotPWD
        // },
        url,
        data,
      });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  }
}
